import { DatePipe } from "@angular/common";
import { Inject, LOCALE_ID, Pipe } from "@angular/core";
import * as moment from "moment"; // NOSONAR: This import is necessary for moment usage. Default import doesn't work.
import { Moment } from "moment";

type DatePipeValue = Date | string | number | null | undefined;
type MomentDatePipeValue = Moment | Date | string | number | null | undefined;

@Pipe({ name: 'date', pure: true })
export class MomentDatePipe extends DatePipe {
  constructor(
    @Inject(LOCALE_ID) locale: string,
  ) {
    super(locale)
  }

  transform(value: Date | string | number, format?: string, timezone?: string, locale?: string): string | null;
  transform(value: null | undefined, format?: string, timezone?: string, locale?: string): null;
  transform(value: DatePipeValue, format?: string, timezone?: string, locale?: string): string | null;
  transform(value: MomentDatePipeValue, format?: string, timezone?: string, locale?: string): string | null;

  transform(value: MomentDatePipeValue, format?: string, timezone?: string, locale?: string): string | null {
    if (moment.isMoment(value)) {
      return value.format(format);
    }
    return moment(value).format(format);
  }

}
